import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/auth/me/').then(r => setUser(r.data)).catch(() => setUser(null)).finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const r = await api.post('/auth/login/', { username, password });
    if (r.data.token) localStorage.setItem('auth_token', r.data.token);
    setUser(r.data);
    return r.data;
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout/');
    } catch (e) { /* ignora erros de rede */ } finally {
      localStorage.removeItem('auth_token');
      setUser(null);
      document.cookie = 'sessionid=; Max-Age=0; path=/';
      document.cookie = 'csrftoken=; Max-Age=0; path=/';
      window.location.href = '/login';
    }
  };

  const isChefe            = () => user?.perfil_acesso === 1;
  const isVendedor         = () => user?.perfil_acesso === 2;
  const isGerenteComercial = () => user?.perfil_acesso === 3;
  const isPreVenda         = () => user?.perfil_acesso === 4;
  const isPosVenda         = () => user?.perfil_acesso === 5;
  const isEngenheiro       = () => user?.perfil_acesso === 6;
  const isInstalador       = () => user?.perfil_acesso === 7;

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isChefe, isVendedor, isGerenteComercial, isPreVenda, isPosVenda, isEngenheiro, isInstalador }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
